import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { onboardingService } from '../../../application/OnboardingService';
import useErrorMiddleware from '../../../hooks/errorMiddleware/useErrorMiddleware';
import { getOrganizationResourcesMutationKey } from '../../../hooks/organization';
import { useShowSnackbarMessage } from '../../../hooks/snackbarMessage/useShowSnackbarMessage';
import { CreateOrganizationOnboardingResponse } from '../../../repositories/onboarding/OnboardingRepository';

export type CreateOrganizationOnboardingData = CreateOrganizationOnboardingResponse;

type UseCreateOrganizationOnboardingResponse = ServiceResponse<Function, CreateOrganizationOnboardingData | undefined>;

// Hooks act as 'Adapter' layer.
export const useInitializeOnboarding = (): UseCreateOrganizationOnboardingResponse => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const queryClient = useQueryClient();

  const { isLoading, data, isSuccess, isError, mutate } = useMutation(
    (plan_name?: string): Promise<CreateOrganizationOnboardingResponse> =>
      onboardingService.initializeOnboarding(plan_name),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getOrganizationResourcesMutationKey());
      },
      onError: (err: any) => {
        console.info(`Initialize Onboarding Error:`, err);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: (plan_name: string) => mutate(plan_name),
    data,
  };
};
